import React from 'react'

export default function Footer() {
  return (
    <div>
          <div className="grid grid-cols-12 gap-4 p-5 pb-2">
            <div className="col-span-6 md:col-span-12 text-sm text-end opacity-75 hover:opacity-100">
              <span>Copyright &copy; 2024 - dev by: <a href="https://rezweb.my.id" className="link  link-secondary" target="_blank" rel="noopener noreferrer">https://rezweb.my.id</a> </span>
            </div>
          </div>
    </div>
  )
}
